/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Too_Many_SessionsInputs */

const en_us2_plan_too_many_sessions = /** @type {(inputs: Plan_Too_Many_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan is already at its limit of workouts. Delete one before adding another.`)
};

const pt_br2_plan_too_many_sessions = /** @type {(inputs: Plan_Too_Many_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano já está no limite de treinos. Exclua um antes de adicionar outro.`)
};

const es_419_plan_too_many_sessions = /** @type {(inputs: Plan_Too_Many_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El plan ya llegó a su límite de entrenamientos. Elimina uno antes de agregar otro.`)
};

const pt_pt2_plan_too_many_sessions = /** @type {(inputs: Plan_Too_Many_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano já está no limite de treinos. Elimina um antes de adicionares outro.`)
};

const fr_fr2_plan_too_many_sessions = /** @type {(inputs: Plan_Too_Many_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le programme a déjà atteint sa limite de séances. Supprimes-en une avant d'en ajouter une autre.`)
};

const de_de2_plan_too_many_sessions = /** @type {(inputs: Plan_Too_Many_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Plan hat bereits die maximale Anzahl an Trainings. Lösch eins, bevor du ein weiteres hinzufügst.`)
};

const it_it2_plan_too_many_sessions = /** @type {(inputs: Plan_Too_Many_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scheda ha già raggiunto il limite di allenamenti. Eliminane uno prima di aggiungerne un altro.`)
};

/**
* | output |
* | --- |
* | "The plan is already at its limit of workouts. Delete one before adding another." |
*
* @param {Plan_Too_Many_SessionsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_too_many_sessions = /** @type {((inputs?: Plan_Too_Many_SessionsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Too_Many_SessionsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_too_many_sessions(inputs)
	if (locale === "es-419") return es_419_plan_too_many_sessions(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_too_many_sessions(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_too_many_sessions(inputs)
	if (locale === "de-DE") return de_de2_plan_too_many_sessions(inputs)
	if (locale === "it-IT") return it_it2_plan_too_many_sessions(inputs)
	return en_us2_plan_too_many_sessions(inputs)
});
export { plan_too_many_sessions as "plan.too_many_sessions" }